import React from 'react';
import PropTypes from 'prop-types';
import { graphql, useStaticQuery } from 'gatsby';
import styled from '@emotion/styled';

import useUserContext from '../hooks/use-user-context';
import { createOptionMap } from '../utilities/misc';

const PhoneNumber = styled.span`
  white-space: nowrap;

  ${({ first }) => first && `
    margin-right: 5px;
  `}
`;

const PhoneSalesSupport = ({ salesPhone, supportPhone }) => {
  const data = useStaticQuery(graphql`
    query PhoneSalesSupport {
      allContentfulOptionSet(filter: {name: {eq: "globals"}}) {
        nodes {
          ...OptionSetFragment
        }
      }
    }
  `);
  const { language } = useUserContext();
  const options = createOptionMap(data.allContentfulOptionSet.nodes, language);

  return (
    <>
      {salesPhone && (
        <PhoneNumber first>{`${options['globals.phone_number_sales']} ${salesPhone} `}</PhoneNumber>
      )}
      {supportPhone && (
        <PhoneNumber>{`${options['globals.phone_number_support']} ${supportPhone}`}</PhoneNumber>
      )}
    </>
  );
};

PhoneSalesSupport.propTypes = {
  salesPhone: PropTypes.string,
  supportPhone: PropTypes.string
};

export default PhoneSalesSupport;
